<template>
  <div>
    <div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
        :label-position="'top'"
      >
        <el-form-item label="标题" prop="webBilTitle">
          <el-input v-model="ruleForm.webBilTitle" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="详细内容" prop="webBilContent">
          <el-input
            type="textarea"
            v-model="ruleForm.webBilContent"
            placeholder="1、请填写20字以上问题描述，尽量简洁扼要，准确描述事件发生时间、地点、人物、经过、原因、背景、相关证据（图片、视频）等内容，以便相关部门尽快核实并解决问题。
2、个人隐私信息，如手机号、姓名等填写在页面下方个人信息模块。
3、请勿发布违反管理条例的言论。"
            :rows="9"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item prop="desc">
          <template slot="label">
            <span>添加图片/视频</span>
            <span style="font-size: 14px; color: #999999">（最多上传9张或一个视频）</span>
          </template>
          <div style="display: flex; flex-wrap: wrap">
            <div
              v-for="(item, index) in imagerList"
              :key="index"
              style="
                position: relative;
                height: 1.44rem;
                width: 1.44rem;
                margin-bottom: 0.2rem;
                margin-right: 0.2rem;
                border-radius: 0.08rem;
              "
            >
              <el-image :src="item" @click="preview">
                <div slot="placeholder" class="image-slot">
                  <span>上传中</span>
                </div>
              </el-image>
              <!-- <el-image class="imgView" :src="item" :preview-src-list="imagerList"></el-image> -->
              <i
                class="el-icon-error"
                style="
                  position: absolute;
                  top: 4px;
                  right: 4px;
                  color: rgba(255, 255, 255, 0.8);
                  font-size: 14px;
                "
                @click="delImage(index)"
              ></i>
            </div>
            <el-upload
              v-if="videoPath == '' && imagerList.length != 9"
              accept=".jpg, .jpeg, .png, .gif, .mp4, .ogg, .flv, .avi, .wmv, .rmvb, , mov, .quicktime"
              action
              list-type="picture-card"
              :limit="9"
              :show-file-list="false"
              :before-upload="
                (file) => {
                  return beforeVideoUpload(file);
                }
              "
            >
              <i
                slot="default"
                class="el-icon-plus"
                style="
                  font-size: 0.6rem;
                  color: rgb(199, 202, 211);
                  font-weight: 600;
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform: translate(-50%, -50%);
                  font-weight: 600;
                "
              ></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="单位类型">
          <el-select
            v-model="ruleForm.region"
            placeholder="请选择单位类型"
            @change="getUntil"
            size="small"
            style="width: 100%"
            :disabled="classDis"
          >
            <el-option
              v-for="item in allClassList"
              :key="item.webClasId"
              :label="item.webClasName"
              :value="item.webClasId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单位">
          <el-select
            v-model="ruleForm.webPolId"
            placeholder="请选择单位"
            :disabled="unitDis||ruleForm.region == ''"
            size="small"
            style="width: 100%"
          >
            <el-option
              v-for="item in unitOptions"
              :key="item.webPlatId"
              :label="item.webPlatName"
              :value="item.webPlatId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问政类型" prop="webBilType">
          <el-radio-group v-model="ruleForm.webBilType">
            <el-radio :label="0">咨询</el-radio>
            <el-radio :label="2">投诉</el-radio>
            <el-radio :label="1">建议</el-radio>
            <el-radio :label="3">求助</el-radio>
            <el-radio :label="4">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="真实姓名" prop="webRealName">
          <el-input v-model="ruleForm.webRealName" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="webUserMobile">
          <el-input
            maxlength="11"
            show-word-limit
            v-model="ruleForm.webUserMobile"
            placeholder="请输入验证码"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="smsCode">
          <el-input
            style="width: 63%; margin-right: 0.24rem"
            v-model="ruleForm.smsCode"
            placeholder="请输入手机号"
          ></el-input>
          <el-button
            type="primary"
            :style="{
              width: '33%',
              padding:'10px 20px',
              background: typeSms ? '#F5F5F5 !important' : '',
              borderColor: typeSms ? '#F5F5F5 !important' : '',
              color: typeSms ? '#666666 !important' : '',
            }"
            @click="getSms"
          >
            {{
            !typeSms ? "获取验证码" : "重新获取" + "(" + timeNUm + "s" + ")"
            }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            class="submit"
            type="primary"
            @click="submitForm"
            style="
              width: 74%;
              margin-left: 50%;
              transform: translateX(-50%);
              margin-top: 0.6rem;
            "
            round
          >提交</el-button>
        </el-form-item>
      </el-form>
    </div>

    <van-overlay :show="show">
      <div class="wrapper">
        <div class="block">
          <p>网络问政平台留言须知</p>
          <div class="content" style="line-height: 20px;">
            <div v-html="content" style></div>
          </div>
          <div class="footer">
            <van-button type="default" size="small" @click="$router.go(-1)" round>拒绝</van-button>
            <van-button
              type="primary"
              size="small"
              @click="show = false"
              :disabled="time != 0"
              round
            >
              同意
              <span v-if="isShow">（{{ time }}s）</span>
            </van-button>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { upFile } from "../../api/onternetPolitics";
import { filePerviewPath } from "../../api/ActivitySolicitation";
import {
  subscriptionManagerPage,
  subscriptionPage,
  addPolitics,
  getTenantGroup
} from "@/api/onternetPolitics/index.js";
import { getCheckPic } from "@/api/login";
import { Toast } from "vant";
import { weChatSharing } from "@/utils/app.js";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      show: false,
      time: 3,
      isShow: true,
      typeSms: false,
      ruleForm: {
        webAttType: 1,
        fileObjIds: [],
        region: "",
        webPolId: "",
        webBilType: 0,
        webUserMobile: ""
      },
      rules: {
        webBilTitle: [
          { required: true, message: "请输入标题", trigger: "blur" }
        ],
        webBilContent: [
          { required: true, message: "请输入问政内容", trigger: "blur" }
        ],
        webBilType: [
          { required: true, message: "请选择问政类型", trigger: "blur" }
        ],
        webRealName: [
          { required: true, message: "请输入您的名字", trigger: "blur" }
        ],
        webUserMobile: [
          { required: true, message: "请输入您的手机号", trigger: "blur" },
          {
            required: true,
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      imagerList: [], //上传资源
      videoPath: "", //视频播放地址
      unitOptions: [],
      allClassList: [],
      timeNUm: null,
      content: "",
      classDis:false,
      unitDis:false,
    };
  },
  created() {
    weChatSharing();
    getTenantGroup({ comConfType: 15 }).then(({ data }) => {
      if (data.code == 200) {
        console.log(data.data);
        this.content = data.data.PolReplyNotics;
      }
    });
  },
  mounted() {
    document.title = "我要反映";
    this.show = true;
    let timer = setInterval(() => {
      this.time--;
      if (this.time == 0) {
        clearInterval(timer);
        this.isShow = false;
      }
    }, 1000);
    this.getOptions();
  },
  methods: {
    onSubmit() {},
    beforeVideoUpload(file) {
      console.log(file);
      let formData = new FormData();
      formData.append("file", file);
      upFile(formData).then(({ data }) => {
        console.log('data',data);
        if (data.code == 200) {
          let obj = {
            id: data.data,
            type: "cover"
          };

          if (file.type.indexOf("video") != -1) {
            this.ruleForm.webAttType = 2;
            this.videoPath = filePerviewPath({
              id: data.data,
              type: "transcode"
            });
            this.imagerList = [];
            this.ruleForm.fileObjIds = [];
          } else if (file.type.indexOf("audio") != -1) {
            this.ruleForm.webAttType = 3;
          } else {
            this.ruleForm.webAttType = 4;
          }
         
          this.imagerList.push(filePerviewPath(obj));
          this.ruleForm.fileObjIds.push(data.data);
        }
      });
    },
    delImage(val) {
      this.videoPath = "";
      this.imagerList.splice(val, 1);
      this.ruleForm.fileObjIds.splice(val, 1);
    },
    //获取单位
    getUntil(val) {
      subscriptionManagerPage({
        pageSize: 0,
        webPlatType: 1,
        webClasId: val,
        webPlatStatus: 1
      }).then(res => {
        if (res.data.code == 200) {
          this.unitOptions = res.data.data;
          this.ruleForm.webPolId = "";
          this.unitOptions.forEach(item=>{
            if (this.$route.query.webPolId && item.webPlatId == this.$route.query.webPolId) {
              
              this.unitDis = true
              this.ruleForm.webPolId = item.webPlatId
            }
          })
        }
      });
    },
    // 获取分类下拉选择
    getOptions() {
      subscriptionPage({ pageSize: 0, webPlatType: 1 }).then(res => {
        if (res.data.code == 200) {
          this.allClassList = res.data.data;
          this.allClassList.forEach(item => {
            if (this.$route.query.webClasId && item.webClasId == this.$route.query.webClasId){
              this.ruleForm.region = item.webClasId
              this.classDis = true
              this.getUntil(item.webClasId)
            }
          });
        }
      });
    },
    //获取短信验证码
    getSms() {
      if (this.ruleForm.webUserMobile == "") {
        Toast("请填写手机号");
        return false;
      }
      getCheckPic({ webUserMobile: this.ruleForm.webUserMobile }).then(
        ({ data }) => {
          if (data.code == 200) {
            this.typeSms = true;
            this.timeNUm = 60;
            let timer = setInterval(() => {
              this.timeNUm--;
              if (this.timeNUm == 0) {
                clearInterval(timer);
                this.typeSms = false;
              }
            }, 1000);
          }
        }
      );
    },
    //提交问政
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          addPolitics(this.ruleForm).then(({ data }) => {
            if (data.code == 200) {
              Toast("提交成功");
              // this.$router.push("/InternetPolitics");
              this.$router.push({ path: '/InternetPolitics', query:{webTenId: this.$route.query.webTenId,webClasId:this.$route.query.webClasId,webPolId:this.$route.query.webPolId } })
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    preview() {
      // console.log(this.detailData.fileObjIds);
      ImagePreview(this.imagerList);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-button--primary {
  background: #e85c30 !important;
  border-color: #e85c30 !important;
}
.submit {
  background: linear-gradient(
    90deg,
    #f96443 0%,
    rgba(239, 109, 53, 0.8) 100%
  ) !important;
  border-color: #ff8743 !important;
}
/deep/.el-button {
  // padding: 10px 20px !important;
}
/deep/.el-radio {
  color: "#333";
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #e85c30 !important;
  background: #e85c30 !important;
}
/deep/.el-select .el-input__inner:focus {
  border-color: #dcdfe6;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #606266;
}
/deep/.el-select .el-input.is-focus .el-input__inner {
  border-color: #dcdfe6;
}
/deep/.el-radio__inner {
  width: 12px !important;
  height: 12px !important;
}
/deep/.el-radio__label {
  padding-left: 8px;
}
/deep/.el-radio__inner::after {
  width: 6px !important;
  height: 6px !important;
}
/deep/.el-radio {
  margin-right: 0.36rem !important;
}
/deep/.el-upload--text {
  width: 1.44rem;
  height: 1.44rem;
  border: 1px dashed #6666;
  background: #f5f5f5;
}
.demo-ruleForm {
  padding: 0.24rem 0.4rem 0.88rem;
  overflow: hidden;
}
/deep/.el-form--label-top .el-form-item__label {
  padding: 0 !important;
  // float: left;
  line-height: 22px;
  margin-bottom: 0.24rem;
  font-size: 16px;
  font-weight: 600;
}
/deep/.el-form-item {
  margin-bottom: 20px !important;
  display: flex;
  flex-direction: column;
}
/deep/.el-input__inner {
  height: 36px;
  line-height: 36px;
}
/deep/.el-upload--picture-card {
  width: 1.44rem !important;
  height: 1.44rem !important;
  background-color: #F5F5F5;
  position: relative;
  border: none;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.6);
  max-width: 460px;
  left: 50%;
  transform: translateX(-50%);
}
.imgView {
  width: 1.44rem;
  height: 1.44rem;
}
.block {
  width: 92%;
  background: #fff;
  height: 11.42rem;
  margin: 1rem auto;
  padding: 0.64rem 0.4rem 0.38rem 0.64rem;
  box-sizing: border-box;
  border-radius: 0.2rem;
  > p {
    font-size: 0.32rem;
    text-align: center;
  }
  .content {
    margin: 0.4rem 0 0.24rem;
    font-size: 0.24rem;
    color: #666666;
    height: 79%;
    overflow-y: auto;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    /deep/.van-button {
      height: 36px;
      line-height: 36px;
      width: 48%;
      border-radius: 0.2rem;
    }
    /deep/.van-button__text {
      display: flex;
      align-items: center;
    }
    /deep/.van-button--primary {
      background: #e85c30;
      border: none;
    }
  }
}
</style>
